import {enableProdMode} from '@angular/core';
import {platformBrowser} from '@angular/platform-browser';
import {initAdminUiI18n} from './app/admin-shared/i18n/i18n-init';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

(async () => {
  // Переводы должны быть готовы ДО загрузки кода приложения: конфиги форм и
  // шаблонные $localize-константы вычисляются при импорте модулей, поэтому
  // AppModule подгружается динамически после initAdminUiI18n().
  await initAdminUiI18n();
  const {AppModule} = await import('./app/app.module');
  platformBrowser()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
})();
